// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"382":"9d7b8ee2","873":"9d7b8ee2"}[chunkId] + ".chunk.css";
};